export function saveImpersonatePrefs(vals) {
    localStorage.setItem('isAdmin', true);
    localStorage.setItem('libs_id', vals);
}

export function removeImpersonatePrefs() {
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('libs_id');
}
